<mat-sidenav-container uikSidenavLayout>
	<mat-sidenav #main [opened]="isDesktop" [mode]="!isDesktop ? 'over' : 'side'" [fixedInViewport]="true" fixedTopGap="0">
		<a [routerLink]="['/home']">
			<uik-sidenav-logo></uik-sidenav-logo>
		</a>
		<mat-nav-list class="d-flex flex-column align-items-start justify-content-center text-center w-100">
			@for (link of navLinks; track link.url) {
				@if (link.ref) {
					<uik-sidenav-navigation-route
						[routerLink]="[link.url]"
						[class.sidenav-item-selected]="isLinkActive(link)"
						class="d-flex align-items-center sidenav__link-label"
						[routeLabel]="link.name"
						[uikSidenavSubNavigationRef]="link.ref"
						(click)="activeLink = link"
					>
						<mat-icon class="material-symbols-rounded text-center sidenav__link-icon">{{ link.icon }}</mat-icon>
					</uik-sidenav-navigation-route>
				} @else {
					<uik-sidenav-navigation-route
						[routerLink]="[link.url]"
						[class.sidenav-item-selected]="isLinkActive(link)"
						class="d-flex align-items-center sidenav__link-label"
						[routeLabel]="link.name"
						(click)="activeLink = link"
					>
						<mat-icon class="material-symbols-rounded text-center sidenav__link-icon">{{ link.icon }}</mat-icon>
					</uik-sidenav-navigation-route>
				}

			}
			@if (!isDesktop) {
				<div class="sidenav__mobile-divider"></div>
				<mat-list-item
					(click)="openProfileMenu(); main.toggle(false)"
					class="d-flex justify-content-start"
				>
					<div class="d-flex w-100 flex-row align-items-center">
						<digital-components-kit-avatar
							[avatarUrl]="
									this.accountService.profileInformations?.picture === ''
										? picture
										: this.accountService.profileInformations?.picture
								"
							[firstname]="
									this.accountService.profileInformations?.firstname === ''
										? firstname
										: this.accountService.profileInformations?.firstname
								"
							[lastname]="
									this.accountService.profileInformations?.lastname === ''
										? lastname
										: this.accountService.profileInformations?.lastname
								"
							class="me-2"
						>
						</digital-components-kit-avatar>
						<span class="uik-body-bold"
						>{{
								this.accountService.profileInformations?.firstname === ''
									? firstname
									: this.accountService.profileInformations?.firstname
							}}
							{{
								this.accountService.profileInformations?.lastname === ''
									? lastname
									: this.accountService.profileInformations?.lastname
							}}</span
						>
					</div>
				</mat-list-item>
				@if (accountService.profileInformations.email || accountService.connectedUserToken?.guid) {
					<mat-list-item class="d-flex justify-content-start sidenav__mobile-link">
						<digital-bookmark-front-list />
					</mat-list-item>
				}
				<mat-list-item>
					<digital-company-switcher />
				</mat-list-item>
			}
		</mat-nav-list>
		@if (!isDesktop) {
			<uik-sidenav-sub-navigation position="sidenav"></uik-sidenav-sub-navigation>
		}
	</mat-sidenav>
	<mat-sidenav-content>
		<div class="d-flex w-100 align-items-center sidenav__header-container">
			@if (!isDesktop) {
				<button
					type="button"
					aria-label="toggle sidenav"
					matIconButton
					(click)="main.toggle(true)"
					class="me-2 sidenav__header-mobile-toggle"
				>
					<mat-icon aria-label="sidenav toggle icon">menu</mat-icon>
				</button>
			}
			@if (isLaptop || activeLink.ref == undefined) {
				<app-portal-contextual-heading
					class="w-100"
					[contextualHeading]="contextualHeading_headlines"
				/>
			}
		</div>
			@if (!isLaptop && activeLink.ref !== undefined) {
				<div class="d-flex sidenav__content-with-subnav">
					<uik-sub-navigation [ref]="activeLink.ref"></uik-sub-navigation>
					<div class="d-flex flex-column sidenav__content-main">
						<app-portal-contextual-heading
							class="w-100"
							[contextualHeading]="contextualHeading_headlines"
						/>
						<div class="sidenav__content-main-scroll">
							<div class="pt-6">
								<router-outlet></router-outlet>
							</div>
							@if (isDesktop) {
								<uik-sidenav-sub-navigation></uik-sidenav-sub-navigation>
							}
						</div>
					</div>
				</div>
			} @else {
				<div class="sidenav__content-main-scroll">
					<div class="pt-6">
						<router-outlet></router-outlet>
					</div>
					@if (isDesktop) {
						<uik-sidenav-sub-navigation></uik-sidenav-sub-navigation>
					}
				</div>
			}
	</mat-sidenav-content>
</mat-sidenav-container>
